/*
 * @Author: fangheng fangheng@wedobest.com.cn
 * @Date: 2023-07-03 17:15:48
 * @LastEditors: fangheng fangheng@wedobest.com.cn
 * @LastEditTime: 2023-07-07 20:09:05
 * @FilePath: \purchase-web\src\api\payManage\payManage.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/**
 * Create by zhuzhaoqing
 * Description: permission
 * Date: 2023/3/31 16:05
 **/
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import request from '../request'

const serveName = process.env.VUE_APP_SERVENAME

// 支付类型查询接口
export const getPayChannel = () => request(`${serveName}/merchants/payChannel`, null, 'GET')
// 主体查询接口
export const getEntity = () => request(`${serveName}/merchants/entity`, null, 'GET')
// 主体查询接口
export const getEntityBuFen = () => request(`${serveName}/merchants/entity/query`, null, 'GET')
// 列表查询
export const getQueryList = (data: any) => request(`${serveName}/merchants/list`, null, 'POST_JSON', data)
// 查询主体配置
export const getQuery = (data: any) => request(`${serveName}/merchants/query`, data, 'GET')
// 查询主体配置
export const getConfig = (data: any) => request(`${serveName}/app/paychnl/merchant/config`, null, 'POST_JSON', data)
// 新增主体配置
export const postSave = (data: any) => request(`${serveName}/merchants/save`, null, 'POST_JSON', data)
// 修改主体配置
export const postEdit = (data: any) => request(`${serveName}/merchants/edit`, null, 'POST_JSON', data)
// 抖音增值税税率查询接口
export const getSysconfig = () =>
  request(`${serveName}/sysconfig/config/DOUYIN_VALUE_ADDED_TAX_RATE`, null, 'GET', null)
// 账号列表查询接口
export const queryAccountList = (data: any) => request(`/${serveName}/account/list`, null, 'POST_JSON', data)
// 账号详情查询接口
export const queryAccountInfo = (data: any) => request(`/${serveName}/account/query`, null, 'POST_JSON', data)
// 账号编辑接口
export const saveAccountInfo = (data: any) => request(`/${serveName}/account/save`, null, 'POST_JSON', data)
// 计算分成比例
export const calDivide = (data: any) => request(`/${serveName}/app/calDivide`, null, 'POST_JSON', data)
